import { OrderPayment, PaymentMethodKey } from '@pedix-workspace/utils';
import { isBuiltInPaymentMethodKey } from './cash-session-amounts';
import { getCustomerPayments, getOrderCollectedMethodKeys } from './order-payment-totals';
import { OrderListItem, getOrderListItemPaymentMethod } from './order-item.utils';

type Translate = (key: string) => string;

export const getPaymentMethodKeyLabel = (
  methodKey: PaymentMethodKey,
  translate: Translate,
): string => {
  if (isBuiltInPaymentMethodKey(methodKey)) {
    return translate(`cashRegister.methods.${methodKey}`);
  }
  return methodKey;
};

const getOrderCollectedMethodLabels = (
  payments: OrderPayment[] | undefined,
  translate: Translate,
): string[] => {
  return [
    ...new Set(
      getOrderCollectedMethodKeys(payments).map(methodKey =>
        getPaymentMethodKeyLabel(methodKey, translate),
      ),
    ),
  ];
};

export const getOrderCollectedMethodsLabel = (
  payments: OrderPayment[] | undefined,
  translate: Translate,
): string => {
  return getOrderCollectedMethodLabels(payments, translate).join(', ');
};

export const getOrderPaymentMethodLabels = (
  order: OrderListItem,
  translate: Translate,
): string[] => {
  const collectedLabels = getOrderCollectedMethodLabels(
    getCustomerPayments(order.payments ?? []),
    translate,
  );

  if (collectedLabels.length > 0) {
    return collectedLabels;
  }
  const chosenLabel = getOrderListItemPaymentMethod(order);

  return chosenLabel ? [chosenLabel] : [];
};

export const getOrderPaymentMethodLabel = (order: OrderListItem, translate: Translate): string => {
  return getOrderPaymentMethodLabels(order, translate).join(', ');
};
